import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Grid,
  CircularProgress,
} from "@mui/material";
import axios from "axios";

export default function RunnerSummary() {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFetch = async () => {
    if (!fromDate || !toDate) {
      alert("يرجى إدخال جميع الحقول");
      return;
    }

    const accessToken = localStorage.getItem("accessToken");
    const runnerId = localStorage.getItem("runnerId");

    if (!accessToken || !runnerId) {
      alert("الرجاء تسجيل الدخول أولاً");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        "https://anydev.com-eg.net/api/RunnersActivity/V1/RunnerDays2DataSummaryEx",
        {
          fromDate: `${fromDate}`,
          toDate: `${toDate}`,
          runnerID: parseInt(runnerId),
        },
        {
          headers: {
            CompanyID: "241701",
            AccessToken: accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      setData(response.data?.data?.[0] || null);
    } catch (error) {
      console.error(error);
      alert("❌ حدث خطأ أثناء جلب البيانات");
    } finally {
      setLoading(false);
    }
  };

  const summaryItems = data
    ? [
        { label: "عدد الساعات", value: data.runningHours },
        { label: "السلف", value: data.loans },
        { label: "المكافآت", value: data.rewards },
        { label: "الجزاءات", value: data.penalties },
        { label: "عدد الأوردرات", value: data.assignedOrders },
        { label: "العمولة المحسوبة", value: data.calculatedSalary },
        { label: "الراتب المستحق", value: data.calculatedSalary },
      ]
    : [];

  return (
    <Box sx={{ p: 2, maxWidth: 800, mx: "auto", direction: "rtl" }}>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Box sx={{ width: "300px" }}>
          <TextField
            fullWidth
            label="من تاريخ"
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Box>
        <Box sx={{ width: "300px" }}>
          <TextField
            fullWidth
            label="إلى تاريخ"
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Box>
        <Box sx={{ width: "300px" }}>
          <button style={styles.button} onClick={handleFetch}>
            🔍 عرض البيانات
          </button>
        </Box>
      </Grid>

      {loading && (
        <Box textAlign="center" my={3}>
          <CircularProgress />
        </Box>
      )}

      {data && (
        <Box sx={{ width: "150px" }}>
          {summaryItems.map((item, index) => (
            <Box sx={{ width: "150px" }} key={index}>
              <Card sx={styles.card}>
                <CardContent sx={styles.cardContent}>
                  <Typography variant="subtitle2" sx={styles.label}>
                    {item.label}
                  </Typography>
                  <Typography variant="h6" sx={styles.value}>
                    {item.value}
                  </Typography>
                </CardContent>
              </Card>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}

const styles = {
  card: {
    height: 120,
    backgroundColor: "#ffffff",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "transform 0.2s ease",
    "&:hover": {
      transform: "scale(1.02)",
    },
  },
  cardContent: {
    textAlign: "center",
  },
  label: {
    fontWeight: "bold",
    color: "#333",
  },
  value: {
    color: "#1976d2",
    fontWeight: "bold",
    fontSize: "20px",
  },
  button: {
    padding: "12px",
    fontSize: "16px",
    backgroundColor: "#1976d2",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    width: "100%",
  },
};
